import gql from 'graphql-tag';

export const Meta = gql`
  fragment Meta on Meta {
    _id
    metaType
    value
    validatedAtStr
  }
`;

export const User = gql`
  fragment User on User {
    _id
    firstName
    lastName
    email
    phone
    company
    city
    street
    role
    userStatus
  }
`;

export const Window = gql`
  fragment Window on Window {
    _id
    name
    validatedAtStr
    winType {
      ...Meta
    }
    winClass {
      ...Meta
    }
    variation {
      ...Meta
    }
    uValueFrame {
      ...Meta
    }
    uValueGlass {
      ...Meta
    }
    windLoad {
      ...Meta
    }
    drivingRain {
      ...Meta
    }
    psiValue {
      ...Meta
    }
    rainRackType {
      ...Meta
    }
    coatingType {
      ...Meta
    }
    wingSeal {
      ...Meta
    }
    foldSeal {
      ...Meta
    }
    glassType {
      ...Meta
    }
    placeholder {
      ...Meta
    }
    rainRackProd {
      ...Meta
    }
    coatingProd {
      ...Meta
    }
    sealProd {
      ...Meta
    }
    profileDie {
      ...Meta
    }
    airPermeable {
      ...Meta
    }
    operateForce {
      ...Meta
    }
    mechanicalStress {
      ...Meta
    }
    mechanicalStress {
      ...Meta
    }
    thermalInsulation {
      ...Meta
    }
    soundInsulation {
      ...Meta
    }
    serialNumber
    qualityReportNumber
    height
    width
    completeSurface
    document
    drawing
    drawingThumbnail
  }
  ${Meta}
`;



// WEBPACK FOOTER //
// ./src/qql-shared/fragments.js